import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalMessages from "@faire/web-api--source/routes/www/brand-portal/messages";
import React, { type JSX } from "react";

import { Bold } from "../../common/Bold";
import { LiItem } from "../../common/LiItem";

export const SOYOProcessing: React.FC = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="To update the tracking information for an order that hasn’t been shipped yet, follow these steps:"
          description={{
            text: "The description for the instant answer about updating shipping information",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Navigate to your Orders tab, and select the order you wish to update."
              description={{
                text: "The first step content in the update tracking info",
              }}
            />
          </Typography>
        </LiItem>
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="On the order details page, choose the Edit option next to the shipping details."
              description={{
                text: "The second step content in the update tracking info",
              }}
            />
          </Typography>
        </LiItem>
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Update the necessary shipping information such as carrier, tracking number, and expected ship date."
              description={{
                text: "The third step content in the update tracking info",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="We also recommend letting your retailer know about the changes to shipping details through <ButtonFormatting>Faire Messenger</ButtonFormatting> to avoid confusion."
          description={{
            text: "The description for the instant answer about updating shipping information",
          }}
          values={{
            ButtonFormatting: (chunks: JSX.Element) =>
              FaireMessagingFormatting(chunks),
          }}
        />
      </Typography>
    </Column>
  );
};

const FaireMessagingFormatting = (chunks: JSX.Element) => (
  <Button variant="tertiary" linkTo={brandPortalMessages()} target="_blank">
    <Bold>{chunks}</Bold>
  </Button>
);
